import { FormSectionHandler } from '../entity.handler';
import { DeviceProviderResponse, DeviceProviderUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';
interface EditorValues {
    [key: string]: string;
}

export class DeviceProviderParametersSectionHandler implements FormSectionHandler<DeviceProviderResponse, EditorValues> {

    type = 'form';
    icon = 'wrench';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.DEVICEPROVIDER.PARAMETERS.${key}`, values);
    }

    applyUpdate(entity: DeviceProviderResponse, payload: DeviceProviderUpdateRequest): Promise<DeviceProviderResponse> {
        return this.admin.applyUpdate(api => api.entities.updateDeviceProvider(entity.id, payload));
    }

    async mapEntityToEditor(entity: DeviceProviderResponse): Promise<EditorValues> {
        return entity.parameters || {};
    }

    mapEditorToEntity(entity: DeviceProviderUpdateRequest, values: EditorValues): Promise<DeviceProviderUpdateRequest> {
        const patch: DeviceProviderUpdateRequest = {
            parameters: values,
        };
        return Promise.resolve(EntityUtils.mergeFields(['parameters'], patch, entity));
    }

    async getFields(entity: DeviceProviderResponse): Promise<FormBuilderField[]> {
        if (entity.deviceProviderType) {
            const deviceProviderType = await this.admin.getCached(`getDeviceProviderType/${entity.deviceProviderType.id}`, api => api.entities.getDeviceProviderType(entity.deviceProviderType.id));
            const params = JSON.parse(deviceProviderType.parameters);
            let fields: FormBuilderField[] = [];
            params.groups.forEach(group => {
                group.fields.forEach(field => {
                    // Add getText function for combo fields to show display value instead of key
                    if (field.type === 'combo' && field.values) {
                        field.getText = (field, values) => {
                            const selectedKey = values[field.id];
                            const option = field.values.find(v => v.key === selectedKey);
                            return option ? option.value : selectedKey;
                        };
                    }
                    fields.push(field);
                });
            });

            fields = this.translateFields(fields);
            return EntityUtils.prepareBulk(!entity, [], fields);
        } else {
            return [];
        }
    }

    private translateFields(fields: FormBuilderField[]): FormBuilderField[] {
        return fields.map(field => ({
            ...field,
            title: (() => { 
                //As new providers could be added and some of the titles may differ, we want to default to the original title if the translation is not found.
                const translated = this.translate(`FIELDS.${field.id.toUpperCase()}`); 
                return translated.includes('EDITORS.DEVICEPROVIDER.PARAMETERS') ? field.title : translated; })(),
            description: field.description ? this.translate(`FIELDS.${field.id.toUpperCase()}_DESC`) : undefined,
        }));
    }
}
